'use strict';

var _ = require('lodash');
var recommendationGridStructuralConfig = require('../config/recommendation-grid-structural-config.json');
var recommendationGridTacticalConfig = require('../config/recommendation-grid-tactical-config.json');
var recommendationGridAdaptiveConfig = require('../config/recommendation-grid-adaptive-config.json');
var FaresOptimizerAnalysisRecommendationGridsController = function FaresOptimizerAnalysisRecommendationGridsController($scope, $filter, recommendationTransformationService, recommendationFilterService, columnUtilsService, faresOptimizerFareTooltipService, featureToggleService) {
  $scope.initializeState = function () {
    $scope.screenState.recommendationList = [];
    $scope.screenState.DEFAULT_OPTIONS = {
      groupBy: [{
        field: 'carrier',
        label: 'Carrier'
      }, {
        field: 'market',
        label: 'Market'
      }, {
        field: 'cabin',
        label: 'Cabin'
      }]
    };
    $scope.screenState.orderOptions = {
      groupBy: [{
        field: 'carrier',
        label: 'Host Carrier'
      }, {
        field: 'market',
        label: 'Market'
      }, {
        field: 'cabin',
        label: 'Cabin'
      }],
      sortBy: [{
        field: 'carrier',
        label: 'Host Carrier',
        order: 'asc'
      }, {
        field: 'marketTier',
        label: 'Market Tier',
        order: 'asc'
      }, {
        field: 'recommendationCount',
        label: 'Number of Recommendations',
        order: 'desc'
      }, {
        field: 'avgAbsoluteFareChange',
        label: 'Avg % Fare Change',
        order: 'desc'
      }]
    };
    var columnDisplayStructural = columnUtilsService.createDisplayModel(recommendationGridStructuralConfig);
    var columnDisplayTactical = columnUtilsService.createDisplayModel(recommendationGridTacticalConfig);
    var columnDisplayAdaptive = columnUtilsService.createDisplayModel(recommendationGridAdaptiveConfig);
    $scope.screenState.recommendationGridStructuralSettings = {
      displayModel: columnDisplayStructural,
      settings: {
        selection: true,
        grouping: true,
        sorting: true,
        headerCheckBox: true,
        multiSelect: true,
        tooltips: {
          effectiveTotalFare: faresOptimizerFareTooltipService.getEffectiveFareTooltipContent,
          fbc: faresOptimizerFareTooltipService.getFbcToolTip,
          fareBrandName: faresOptimizerFareTooltipService.getHostFareBrandDescriptionContent,
          displayCompFareBrandName: faresOptimizerFareTooltipService.getCompFareBrandDescriptionContent,
          displayCompFare: faresOptimizerFareTooltipService.getCompetitorFareTooltipContent,
          displayStatus: faresOptimizerFareTooltipService.getRecommendationStatusToolTipContent
        },
        groupedModeTooltips: {
          fbc: faresOptimizerFareTooltipService.getEntryLevelFbcToolTip
        },
        selectiveTooltipRender: {
          fbc: faresOptimizerFareTooltipService.shouldRenderFbcToolTip,
          fareBrandName: faresOptimizerFareTooltipService.shouldRenderHostFareBrandDescriptionToolTip,
          displayCompFareBrandName: faresOptimizerFareTooltipService.shouldRenderCompFareBrandDescriptionToolTip,
          displayCompFare: faresOptimizerFareTooltipService.shouldRenderCompFareToolTip,
          displayStatus: faresOptimizerFareTooltipService.shouldRenderRecommendationStatusToolTip
        }
      }
    };
    $scope.screenState.recommendationGridTacticalSettings = _.clone($scope.screenState.recommendationGridStructuralSettings);
    $scope.screenState.recommendationGridTacticalSettings.displayModel = columnDisplayTactical;
    if (featureToggleService.isEnabled('ADAPTIVE_PRICING_ENABLED')) {
      $scope.screenState.recommendationGridAdaptiveSettings = _.cloneDeep($scope.screenState.recommendationGridStructuralSettings);
      $scope.screenState.recommendationGridAdaptiveSettings.settings.tooltips.effectiveTotalFare = faresOptimizerFareTooltipService.getEffectiveFareAdaptiveTooltipContent;
      $scope.screenState.recommendationGridAdaptiveSettings.settings.tooltips.currentTotalFare = faresOptimizerFareTooltipService.getCurrentFareAdaptiveTooltipContent;
      $scope.screenState.recommendationGridAdaptiveSettings.settings.tooltips.filedTotalFareAmount = faresOptimizerFareTooltipService.getGDSFareAdaptiveTooltipContent;
      $scope.screenState.recommendationGridAdaptiveSettings.settings.tooltips.fbc = faresOptimizerFareTooltipService.getFbcAdaptiveTooltipContent;
      $scope.screenState.recommendationGridAdaptiveSettings.settings.groupedModeTooltips.fbc = faresOptimizerFareTooltipService.getEntryLevelFbcAdaptiveTooltipContent;
      $scope.screenState.recommendationGridAdaptiveSettings.settings.tooltips.journeyTotalFareAmount = faresOptimizerFareTooltipService.getJourneyTotalFareAdaptiveTooltipContent;
      $scope.screenState.recommendationGridAdaptiveSettings.displayModel = columnDisplayAdaptive;
    }
    $scope.screenState.isRawDataPresent = false;
  };
  $scope.recommendationGridSettings = function (screenState) {
    if (screenState.recommendMode === 'STRUCTURAL') return screenState.recommendationGridStructuralSettings;else if (screenState.recommendMode === 'TACTICAL') return screenState.recommendationGridTacticalSettings;else return screenState.recommendationGridAdaptiveSettings;
  };
  $scope.updateRecommendation = function () {
    var data = $scope.screenState.rawData;
    if (data && data.length) {
      var category = $scope.screenState.recommendMode;
      var filters = $scope.screenState.filters;
      var filteredData = recommendationFilterService.filterRawData(data, filters, category);
      $scope.screenState.rawDataByMarket = recommendationTransformationService.getRawDataByMarket(filteredData, $scope.screenState.orderOptions);
      $scope.screenState.displayedRecommendationList = [];
      $scope.screenState.isRawDataPresent = !_.isNil($scope.screenState.rawDataByMarket);
    }
  };
  $scope.setOptions = function () {
    $scope.screenState.showOptionsModal = true;
  };
  $scope.initializeState();
  $scope.$watch('screenState.filters', function () {
    if (_.isNil($scope.screenState.reorderGroupOptions) || $scope.screenState.reorderGroupOptions) {
      $scope.updateRecommendation();
    }
    $scope.screenState.reorderGroupOptions = true;
  }, true);
  $scope.$watch('screenState.filters', function () {
    if (_.isNil($scope.screenState.reorderGroupOptions) || $scope.screenState.reorderGroupOptions) {
      $scope.updateRecommendation();
    }
    $scope.screenState.reorderGroupOptions = true;
  });
  $scope.$watch('screenState.recommendMode', $scope.updateRecommendation, true);
  $scope.$watch('screenState.orderOptions', $scope.updateRecommendation, true);
};
FaresOptimizerAnalysisRecommendationGridsController.$inject = ['$scope', '$filter', 'RecommendationTransformationService', 'RecommendationFilterService', 'SimpleGridColumnUtilsService', 'FaresOptimizerFareTooltipService', 'FeatureToggleService'];
module.exports = FaresOptimizerAnalysisRecommendationGridsController;